<template>
  <div>
    <v-tabs>
      <v-tab href="#tab-1">BOM表</v-tab>
      <v-tab href="#tab-2">虛擬BOM表</v-tab>
      <v-tab-item value="tab-1">
        <default-bom />
      </v-tab-item>
      <v-tab-item value="tab-2">
        <virtual-bom />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import DefaultBom from '@/components/Bom/DefaultBom.vue'
import VirtualBom from '@/components/Bom/VirtualBom.vue'

export default {
  components: { DefaultBom, VirtualBom },
  name: 'Bom',
  data () {
    return {}
  },

  computed: {},
  async mounted () {},
  methods: {}
}
</script>
